import TYPES from '@/modules/shared/types';

// Domain
import { OnBoardingInvitationsStatisticsRepository } from '../../domain/repository';
import { StatisticsDto } from '../../domain/dtos/statistics-dto';
import { StatisticsEntity } from '../../domain/entities/statistics-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class OnBoardingInvitationsStatisticsHttpRepository
implements OnBoardingInvitationsStatisticsRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/dashboard/onboarding-invitation/statistics/`;

  execute(statistics_dto: StatisticsDto): Promise<StatisticsEntity> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint)
        .then((response) => {
          response.json()
            .then(({ data, success, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
